export const SEARCH_PATH = '/search'

export const SEARCH_ROUTE_NAME = 'search'

// Where the new search lived while it was behind the open_search gatekeeper.
// Kept as a redirect to SEARCH_PATH for links already out in the wild.
export const SEARCH_V2_PATH = '/search/v2'
